import { render, staticRenderFns } from "./walkthrough.vue?vue&type=template&id=096e2680&"
import script from "./walkthrough.vue?vue&type=script&lang=js&"
export * from "./walkthrough.vue?vue&type=script&lang=js&"
import style0 from "./walkthrough.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports